'use strict'

export default (mockAxios) => {
  mockAxios.onGet(`/`).reply(200, {
    'success': true,
    'service_version': '20200820 ',
    'service_name': '名刺バンク２',
    'service_owner': 'I-NET Corp.',
    'service_owner_url': 'http://example.com',
    'limit_per_page': 20,
    'company_code': 'k0003',
    'sid_corporate': 1,
    'login_user': {
      'id': 11,
      'loginid': 'yamada',
      'bcard_exportable': '1',
      'last_name': '山田',
      'first_name': '太郎',
      'last_kana': 'やまだ',
      'first_kana': 'たろう',
      'corporate_name': '',
      'corporate_kana': '',
      'dept': '',
      'post': '',
      'zipcode': '',
      'address1': '',
      'address2': '',
      'corporate_tel': '',
      'naisen': '',
      'dept_tel': '',
      'hand_tel': '',
      'fax': '',
      'mail': '',
      'url': '',
      'company_code': 'k0003',
      'as_agent': false,
      'full_name': '山田 太郎',
      'full_kana': 'やまだ たろう',
      'image_url': '',
      'formatted_finallogin': '2019/10/24 19:51:23',
      'formatted_lastlogin': '2019/10/24 16:20:07',
      'is_active': true,
      'is_deleted': false,
      'is_stopped': false,
      'is_admin': true,
      'is_pw_expired': false
    },
    'license': {
      'contract_input': '1',
      'option_nisfa_integration': '1'
    },
    'nisfa_integration': {
      'enable': '1',
      'pv_enable': '1'
    },
    'mobile_company_code_save': '0',
    'mobile_login_id_save': '0',
    'mobile_login_word_save': '0',
    'attachment_max_size': 5
  })

  // // TODO swaggerズレてる
  // mockAxios.onGet(`/top`).reply(200, {
  //   'success': true,
  //   'data': {
  //     'license': {
  //       'use_agency': '1',
  //       'office_name': '株式会社ABC',
  //       'company_code': '000000000000',
  //       'bcard_usage': 57,
  //       'formatted_bcard_usage': '57',
  //       'formatted_contract_count': '10,000',
  //       'formatted_bcard_count': '5,678'
  //     },
  //     'profile': {
  //       'id': 1,
  //       'image_id': '01k200h0173wreha',
  //       'corporate_name': '海山商事',
  //       'dept': 'ソリューション事業部',
  //       'post': '課長',
  //       'mail': 'suzuki@example.jp',
  //       'zipcode': '220-0001',
  //       'address1': '神奈川県横浜市西区みなとみらい',
  //       'address2': 'ランドマークタワー',
  //       'corporate_tel': '045-123-4567',
  //       'dept_tel': '045-123-5678',
  //       'naisen': 1234,
  //       'hand_tel': '090-1234-4567',
  //       'fax': '045-123-5678',
  //       'url': 'http://www.example.jp',
  //       'user_state': 0,
  //       'full_name': '山田 一郎',
  //       'full_kana': 'やまだ いちろう',
  //       'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
  //       'valid_url': 'http://www.example.jp'
  //     },
  //     'agents': [
  //       {
  //         'id': 1,
  //         'user_state': 0,
  //         'full_name': '山田 一郎'
  //       }
  //     ],
  //     'info_messages': {
  //       data: [
  //         {
  //           'id': 1,
  //           'type': 'T',
  //           'function': '1',
  //           'message': '同一人物判定をしてください',
  //           'unread': '1',
  //           'lang_function': '同一人物判定',
  //           'updated': '2018/01/01 00:00'
  //         }
  //       ],
  //       'pagination': {
  //         'page_count': 5,
  //         'current_page': 1,
  //         'has_next_page': true,
  //         'has_prev_page': false,
  //         'count': 55,
  //         'limit': 10
  //       }
  //     },
  //     'bcard_images': {
  //       data: [
  //         {
  //           'terminal': '1',
  //           'status': '0',
  //           'sid_person': 1,
  //           'id': 1,
  //           'image_id': '01k20094169p8y3t',
  //           'dispname': 'example.jpg',
  //           'exchange_date': '20180101',
  //           'openflag': '1',
  //           'input_proxy': '1',
  //           'formatted_exdate': '2018/01/01',
  //           'formatted_uploadtime': '2018/01/01 00:00:00',
  //           'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
  //           'lang_terminal': 'Web',
  //           'lang_status': '修正サービス依頼中',
  //           'prog_status': '2/3',
  //           'lang_openflag': '公開',
  //           'lang_input_proxy': '利用する'
  //         }
  //       ],
  //       'pagination': {
  //         'page_count': 5,
  //         'current_page': 1,
  //         'has_next_page': true,
  //         'has_prev_page': false,
  //         'count': 55,
  //         'limit': 10
  //       }
  //     },
  //     'exchanged_bcards': {
  //       data: [
  //         {
  //           'id': 1,
  //           'openflag': '1',
  //           'corporate_name': '株式会社RRRコンピューターサービス',
  //           'dept': '公共情報事業本部',
  //           'post': '主任心得',
  //           'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
  //           'full_name': '大森 圭介',
  //           'formatted_exdate': '2018/01/01'
  //         }
  //       ],
  //       'pagination': {
  //         'page_count': 5,
  //         'current_page': 1,
  //         'has_next_page': true,
  //         'has_prev_page': false,
  //         'count': 55,
  //         'limit': 10
  //       }
  //     },
  //     'updated_bcards': {
  //       data: [
  //         {
  //           'id': 1,
  //           'openflag': '1',
  //           'corporate_name': '株式会社RRRコンピューターサービス',
  //           'dept': '公共情報事業本部',
  //           'post': '主任心得',
  //           'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
  //           'full_name': '大森 圭介',
  //           'formatted_exdate': '2018/01/01'
  //         }
  //       ],
  //       'pagination': {
  //         'page_count': 5,
  //         'current_page': 1,
  //         'has_next_page': true,
  //         'has_prev_page': false,
  //         'count': 55,
  //         'limit': 10
  //       }
  //     },
  //     'accessed_bcards': {
  //       data: [
  //         {
  //           'id': 1,
  //           'openflag': '1',
  //           'corporate_name': '株式会社RRRコンピューターサービス',
  //           'dept': '公共情報事業本部',
  //           'post': '主任心得',
  //           'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
  //           'full_name': '大森 圭介',
  //           'formatted_refdate': '2018/01/01'
  //         }
  //       ],
  //       'pagination': {
  //         'page_count': 5,
  //         'current_page': 1,
  //         'has_next_page': true,
  //         'has_prev_page': false,
  //         'count': 55,
  //         'limit': 10
  //       }
  //     },
  //     'favorited_bcards': {
  //       data: [
  //         {
  //           'id': 1,
  //           'sid_assign': 1,
  //           'openflag': '1',
  //           'corporate_name': '株式会社RRRコンピューターサービス',
  //           'dept': '公共情報事業本部',
  //           'post': '主任心得',
  //           'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
  //           'full_name': '大森 圭介'
  //         }
  //       ],
  //       'pagination': {
  //         'page_count': 5,
  //         'current_page': 1,
  //         'has_next_page': true,
  //         'has_prev_page': false,
  //         'count': 55,
  //         'limit': 10
  //       }
  //     }
  //   }
  // })

  mockAxios.onGet(`/sidemenu`).reply(200, {
    'success': true,
    'data': {
      'queues': 4,
      'errors': 3,
      'noimage': 123,
      'nonjudged': 4,
      'pinned': 'my'
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/topRepositoryMock.js